import { defineComponent } from "vue";

export default defineComponent({
  props: {
    label: String,
    value: Boolean,
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  methods: {
    handleInput(event: any) {
      this.$emit("input", event.target.checked);
    },
  },
});
